require('../../../modules/es.array.reduce');
var entryVirtual = require('../../../internals/entry-virtual');

module.exports = entryVirtual('Array').reduce;



//////////////////
// WEBPACK FOOTER
// ./~/core-js-pure/es/array/virtual/reduce.js
// module id = 978
// module chunks = 0